<app-diagnosis-table type="Diseases"></app-diagnosis-table>
